/**
 * 游客可访问页面判定策略
 *
 * 背景：微信/钉钉等内置浏览器会长期保留 holopix 域名的登录 Cookie。
 * 用户此前登录过但 token 已过期时，打开分享画板（/board/share，meta.auth=false）
 * 这类游客可访问页面，鉴权接口会返回 90000；若此时按“登录过期”走整页登出跳转，
 * 就会表现为“加载完不停刷新/跳转”。因此需要先判断当前页面是否允许以游客身份继续访问。
 */

export type GuestRouteResolver = (path: string) => { meta: Record<string, unknown> };

/**
 * 判断当前 URL 是否属于「游客可访问页面」（meta.auth === false，如分享画板 /board/share）。
 *
 * 直接基于当前 URL 解析路由，而不是依赖 router.currentRoute：
 * 首次导航尚未完成时 currentRoute 仍是占位路由，无法反映目标页面的 meta。
 *
 * @param resolve  路由解析函数（生产传入 router.resolve，测试可注入 stub）
 * @param pathname 当前路径，如 /board/share/3489
 * @param search   当前查询串，如 ?traceId=xxx&password=xxx
 */
export function isGuestAccessiblePage(
  resolve: GuestRouteResolver,
  pathname: string,
  search: string
): boolean {
  try {
    const resolved = resolve(`${pathname}${search}`);
    return resolved.meta?.auth === false;
  } catch {
    // 路由解析失败时按非游客页处理，保持原有登出行为，避免误判
    return false;
  }
}
